import eua from './eua.png';
import brasil from './brasil.png';

export default {
  eua,
  brasil,
};
